import { Outlet } from "react-router";
import Header from "./components/Header";

export default function MainLayout() {
  return (
    <div className="flex bg-white font-fish">
      <div className="flex-grow overflow-x-auto">
        <Header />
        <Outlet />
      </div>
    </div>
  );
}
